export default "<p *ngIf=\"training\">\n    Yes\n</p>\n<p *ngIf=\"!training\">\n    No\n</p>\n"